import {takeEvery, call, put} from "redux-saga/effects";
import actionTypes from "_constants/actionTypes";
import {xcService} from "_services/xcService";
import {history} from "_helpers/history";

import variables from "_constants/variables";

import localOrSessionStore from "_helpers/localOrSessionStore";
export default function* watcherAuthentication() {
  yield takeEvery(actionTypes.LOGIN_USER, loginUser);
  yield takeEvery(actionTypes.CHECK_CODE, checkCode);
  yield takeEvery(actionTypes.LOGOUT, logoutUser);
  yield takeEvery(actionTypes.FORGOTPASSWORD, forgotPassword);
  yield takeEvery(actionTypes.RESETPASSWORD, resetPassword);
  yield takeEvery(actionTypes.REGISTER_USER, registerUser);
  yield takeEvery(actionTypes.GET_ACTUAL_YEAR, actualYear);
}

function* actualYear({payload}) {
  yield put({type: actionTypes.START_REQUEST});
  try {
    let apiEndpoint = "/v1/year";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.get(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200) {
      yield put({type: actionTypes.GET_ACTUAL_YEAR_DATA, payload: res.data.data});
    } else {
      yield put({type: actionTypes.GET_ACTUAL_YEAR_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.GET_ACTUAL_YEAR_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* checkCode({payload}) {
  yield put({type: actionTypes.START_REQUEST});
  try {
    let apiEndpoint = "/v1/check/center";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200) {
      yield put({type: actionTypes.CHECK_CODE_DATA, payload: res.data});
    } else {
      yield put({type: actionTypes.CHECK_CODE_ERROR, payload: res.data});
    }
    yield put({type: actionTypes.CLEAN_CHECK_CODE, payload: res.data});
  } catch (e) {
    yield put({type: actionTypes.CHECK_CODE_ERROR, payload: e});
    yield put({type: actionTypes.CLEAN_CHECK_CODE, payload: "ok"});
  }
  yield put({type: actionTypes.END_REQUEST});
}
function* registerUser({payload}) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/student/auth/register";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200) {
      const storage = localOrSessionStore({key: variables.REMEMBER});
      if (res.data.data.auto) {
        storage.setItem(variables.AUTH, "true");
        storage.setItem(variables.COMPLET, "0");
        storage.setItem(variables.TOKEN, res.data.data.token);
        storage.setItem(variables.TOKENREFRESH, res.data.data.refreshToken);
        storage.setItem(variables.USER, JSON.stringify(res.data.data.user));
        storage.setItem(variables.USER_TYPE, "STUDENT");
      }

      yield put({type: actionTypes.REGISTER_USER_DATA, payload: res.data});
      // TODO Autologin
      /*
       */
    } else {
      yield put({type: actionTypes.REGISTER_USER_ERROR, payload: res.data});
    }
    yield put({type: actionTypes.CLEAN_REGISTER_USER, payload: res.data});
  } catch (e) {
    yield put({type: actionTypes.REGISTER_USER_ERROR, payload: e});
    yield put({type: actionTypes.CLEAN_REGISTER_USER, payload: "ok"});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* forgotPassword({payload}) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/user/auth/reset";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200) {
      yield put({type: actionTypes.FORGOTPASSWORD_DATA, payload: res.data});
    } else {
      yield put({type: actionTypes.FORGOTPASSWORD_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.FORGOTPASSWORD_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* resetPassword({payload}) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/user/auth/change";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.postToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200) {
      const storage = localOrSessionStore({key: variables.REMEMBER});
      if (res.status === 200 && res.data.data.token) {
        storage.setItem(variables.AUTH, "true");
        storage.setItem(variables.COMPLET, "0");
        storage.setItem(variables.TOKEN, res.data.data.token);
        storage.setItem(variables.TOKENREFRESH, res.data.data.refreshToken);
        storage.setItem(variables.USER, JSON.stringify(res.data.data.user));
        storage.setItem(variables.USER_TYPE, res.data.data.userType);

        yield put({type: actionTypes.LOGIN_DATA, payload: res.data.data});
        let mUrl = "";
        if (res.data.data.userType === "STUDENT") {
          mUrl = "/admin/dashboard";
        } else if (res.data.data.userType === "FAMILY") {
          mUrl = "/admin/informes";
        } else if (res.data.data.userType === "TUTOR") {
          mUrl = "/tutorAuth/students";
        } else if (res.data.data.userType === "COUNSELOR") {
          mUrl = "/tutorAuth/students";
        } else if (res.data.data.userType === "CENTER") {
          res.data.data?.pendingContract ? (mUrl = "/auth/center/pdf") : (mUrl = "/tutorAuth/students");
        } else if (res.data.data.userType === "MASTER") {
          mUrl = "/tutorAuth/students";
        }

        setTimeout(() => {
          window.location.replace(mUrl);
        }, 300);
      }
    } else {
      yield put({type: actionTypes.RESETPASSWORD_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.RESETPASSWORD_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* loginUser({payload}) {
  if (payload.remember) {
    localStorage.setItem(variables.REMEMBER, "t");
  } else {
    localStorage.setItem(variables.REMEMBER, "f");
  }

  const storage = localOrSessionStore({key: variables.REMEMBER});

  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/user/auth/login";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        }),
    );
    if (res.status === 200 && res.data.data.user.changepass) {
      storage.setItem(variables.USER, JSON.stringify(res.data.data.user));
      history.push("/auth/resetPassword");
    } else {
      if (res.status === 200 && res.data.data.token && res.data.data.userType) {
        storage.setItem(variables.AUTH, "true");
        storage.setItem(variables.COMPLET, "0");
        storage.setItem(variables.TOKEN, res.data.data.token);
        storage.setItem(variables.TOKENREFRESH, res.data.data.refreshToken);
        storage.setItem(variables.USER, JSON.stringify(res.data.data.user));
        storage.setItem(variables.USER_TYPE, res.data.data.userType);

        yield put({type: actionTypes.LOGIN_DATA, payload: res.data.data});
        let mUrl = "";
        if (res.data.data.userType === "STUDENT") {
          mUrl = "/admin/dashboard";
        } else if (res.data.data.userType === "FAMILY") {
          mUrl = "/admin/informes";
        } else if (res.data.data.userType === "TUTOR") {
          mUrl = "/tutorAuth/students";
        } else if (res.data.data.userType === "COUNSELOR") {
          mUrl = "/tutorAuth/students";
        } else if (res.data.data.userType === "CENTER") {
          res.data.data?.pendingContract ? (mUrl = "/auth/center/pdf") : (mUrl = "/tutorAuth/students");
        } else if (res.data.data.userType === "MASTER") {
          mUrl = "/tutorAuth/students";
        }

        setTimeout(() => {
          window.location.replace(mUrl);
        }, 300);
      } else {
        yield put({type: actionTypes.LOGIN_ERROR, payload: res.data});
      }
    }
  } catch (e) {
    yield put({type: actionTypes.LOGIN_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* logoutUser() {
  const storage = localOrSessionStore({key: variables.REMEMBER});

  yield put({type: actionTypes.START_REQUEST});
  storage.setItem(variables.AUTH, "false");
  storage.setItem(variables.COMPLET, "0");
  storage.removeItem(variables.TOKEN);
  storage.removeItem(variables.TOKENREFRESH);
  storage.removeItem(variables.USER);
  yield put({type: actionTypes.LOGIN_DATA, payload: null});
  yield put({type: actionTypes.END_REQUEST});
  history.push("/auth/index");
}
